import { useEffect, useState } from "react";
import { readStoredUser } from "../../utils/sessionUser";

export function receivingPermissions(user, receiving) {
  const can = (key) => Number(user?.id) === 1 || user?.permissions?.[key] === true;
  const ownDraft = receiving?.status === "draft" && Number(receiving?.created_by) === Number(user?.id);
  return {
    create: can("purchasing.receivings.create"),
    update: can("purchasing.receivings.update") || (ownDraft && can("purchasing.receivings.create")),
    delete: can("purchasing.receivings.delete"),
    verify: can("purchasing.receivings.verify"),
    confirmDeliveryNote: can("purchasing.receivings.verify") && can("purchasing.delivery_notes.create"),
    viewDeliveryNotes: can("purchasing.delivery_notes.view_tab"),
    cancelOrderLine: can("purchasing.orders.update"),
    createItem: can("purchasing.items.create"),
  };
}

export function currentReceivingPermissions(receiving) {
  return receivingPermissions(readStoredUser(), receiving);
}

export function useReceivingPermissions(receiving) {
  const [, refresh] = useState(0);
  useEffect(() => {
    const onSessionChanged = () => refresh((value) => value + 1);
    window.addEventListener("palantir-session-updated", onSessionChanged);
    window.addEventListener("storage", onSessionChanged);
    return () => {
      window.removeEventListener("palantir-session-updated", onSessionChanged);
      window.removeEventListener("storage", onSessionChanged);
    };
  }, []);
  return currentReceivingPermissions(receiving);
}
